const INITIAL_STATE = {
  bloqueioEmbarqueList: [],
  bloqueioEmbarque: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'BLOQUEIOEMBARQUELIST_FETCH':
        return { ...state, bloqueioEmbarqueList: action.payload }
      case 'BLOQUEIOEMBARQUE_SET':
        return { ...state, bloqueioEmbarque: action.payload }
      default:
        return state
    }
  }